import type { ReactNode } from "react"
import React from "react"

import BookingSummary from "~components/pages/book/booking-summary"
import CheckoutButtons from "~components/pages/listing/checkout/checkout-buttons"
import type {
    QuoteFieldsFragment,
    QuoteInterfaceFieldsFragment,
    QuoteListingFieldsFragment,
} from "~graphql/generated/graphql"
import COPY from "~config/copy-constants"
import type { OnEditPackageClickFunc } from "~components/shared/quote/quote-package-buttons"

interface Props {
    readonly listing: QuoteListingFieldsFragment
    readonly quote?: QuoteFieldsFragment | null
    readonly draftQuote?: QuoteInterfaceFieldsFragment | null
    readonly isLoading?: boolean
    readonly shouldShowDeleteButtons?: boolean
    readonly onEditPackageClick?: OnEditPackageClickFunc
    readonly renderNavButtons?: () => ReactNode
}

export default function CheckoutFlowSummaryContent({
    listing,
    quote,
    draftQuote,
    isLoading,
    shouldShowDeleteButtons,
    onEditPackageClick,
    renderNavButtons,
}: Props) {
    const { title, note } = getSummaryTitleAndNote({ quoteId: quote?.id })

    return (
        <>
            <BookingSummary
                title={title}
                note={note}
                listing={listing}
                quote={quote ?? draftQuote}
                isQuoteLoading={isLoading}
                shouldShowDeleteButtons={shouldShowDeleteButtons}
                onEditPackageClick={onEditPackageClick}
                shouldShowProcessingFeeWarning={true}
            />
            {renderNavButtons ? (
                renderNavButtons()
            ) : (
                <CheckoutButtons quote={quote} />
            )}
        </>
    )
}

// If there is a quote id, it means we're showing a summary of the entire trip.
// If not, we're showing a summary of the current package being added/updated.
function getSummaryTitleAndNote({ quoteId }: { quoteId?: string }) {
    const title = quoteId ? COPY.TRIP_SUMMARY : COPY.PACKAGE_SUMMARY
    const note = quoteId ? null : COPY.PACKAGE_SUMMARY_NOTE

    return { title, note }
}
